export const iconFontAwesomeConnectivityGlobe = (
	<i className="fa-solid fa-globe"></i>
);
